import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class AlertService {
    private subject = new Subject<any>();
    private keepAfterNavigationChange = false;

    constructor(private router: Router, @Inject(PLATFORM_ID) private platformId: Object) {
        // clear alert message on route change
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterNavigationChange) {
                    // only keep for a single location change
                    this.keepAfterNavigationChange = false;
                } else {
                    // clear alert
                    this.subject.next(undefined);
                }
            }
        });
    }

    success(message: string, keepAfterNavigationChange = false) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'success', text: message });
        this.scrollToAlertBox();
    }

    error(message: string, keepAfterNavigationChange = false) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'error', text: message });
        this.scrollToAlertBox();
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }

    scrollToAlertBox() {
        // Only access DOM in browser environment
        if (isPlatformBrowser(this.platformId)) {
            const e = document.getElementById('content-messages');
            if (e) {
                e.scrollIntoView();
            }
        }
    }

    hide() {
       this.subject.next({ type: null, message: null});
    }
}